module.exports = __webpack_public_path__ + "72a608fe6dec9c08a5bd8ab7144eed16.png";